<button *ngIf="!meetingStarted && !exsistingGroup" (click)="openDialog()" title="Create Group sharing experience with friends"
  style="margin-left: 15px;background: #de1b36;" class="btn btn-light cre-grp-btn ">Create Group</button>
  <button id="startGrpBtn" *ngIf="!meetingStarted && exsistingGroup" (click)="joinExsistingGroup()" title="Create Group sharing experience with friends"
  style="margin-left: 15px;background: #de1b36;" class="btn btn-light cre-grp-btn ">Start Group</button>
{{messages | json}}
<div *ngIf="!meetingStarted" class="join-popup">
  <app-join-group-popup  [eventId]="eventId" (token)="userJoinMeeting($event)">
  </app-join-group-popup>
</div>

<div *ngIf="meetingStarted">
  <div class="row custom-video-box" id="videoContainer" #videoContainer>
  </div>
  <div class="grp-container" fxLayout="row">
    <div fxLayout="row" fxLayoutGap="2%" class="btnContainer">
      <button title="End call" style="background: #DE1B36;" mat-raised-button
        aria-label="Example icon button with a home icon" (click)="leaveMeeting();removeStorage()">
        <img style="width: 28px;" src="assets/icons/group-sharing/call_end.svg">
      </button>
      <button title="Participants" style="background: #DE1B36;" mat-raised-button
        aria-label="Example icon button with a home icon" (click)="openParticipantTemplate()">
        <img style="width: 28px;" src="assets/icons/group-sharing/groups.svg">
      </button>
    </div>
  </div>
</div>
<ng-template #participantList>
  <div class="bottom-sheet-header">{{eventDetails?.description | titlecase}}
    <img style="width: 20px;cursor: pointer;position: absolute;right: 7px;" (click)="closeBottomSheet()" src="assets/icons/group-sharing/cancel-white.svg"
   ></div>
  <mat-form-field class="example-chip-list" appearance="fill" *ngIf="hostUser" style="width: 100%;">
    <mat-label>Add Group Participants</mat-label>
    <mat-chip-list #chipList aria-label="Fruit selection">
      <input class="cus-search-users" placeholder="Enter User Name" #fruitInput [formControl]="myControl"
        [matAutocomplete]="auto" [matChipInputFor]="chipList">
    </mat-chip-list>
    <mat-autocomplete #auto="matAutocomplete">
      <mat-option *ngFor="let option of filteredOptions | async" [value]="option.userId">
       <span  class="cus-bottom-autocomplete" [title]="option.value">{{option.value}}</span>
        <span   title="Request to Join">
          <button mat-button class="btn-join-grp" color="primary"
          (click)="addParticipantsToExsistingEvent(option.userId)">Request to Join</button>
        </span>
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <mat-list #participantsList id="participantsList">
   <!-- Participants ({{totalParticipant}})-->
    <mat-list-item style="color: black !important;">
      <span class="cus-name-list"
        title="{{meeting.localParticipant.displayName | titlecase}}">{{meeting.localParticipant.displayName |
        titlecase}} <p *ngIf="getIsUserHost(meeting.localParticipant)">(Host)</p> </span>
      <span class="cus-icon-container">
        <img style="width: 18px; margin-right: 5px;cursor: pointer;" (click)="toggleWebCam($event)"
          id="listLocalVideo"
          [src]="webCamEnable ? videocam_on :  videocam_off" alt="" #listLocalVideo>
        <img style="width: 20px;cursor: pointer;" (click)="toggleMic($event)" [src]="micEnable ? mic_on : mic_off"
          id="listLocalAudio" alt="" #listLocalAudio>
          <img style="width: 20px;cursor: pointer;" [src]="menu_icon" [matMenuTriggerFor]="menu" *ngIf="webcams.length > 1">
          <mat-menu #menu="matMenu">
              <button mat-menu-item [matMenuTriggerFor]="vertebrates">
                  <span>Change Camera</span>
              </button>

          </mat-menu>
          <mat-menu #vertebrates="matMenu">
              <button mat-menu-item *ngFor="let item of webcams" (click)="changeWebcam(item)">{{item.label}}</button>
          </mat-menu>
      </span>
    </mat-list-item>
    <mat-list-item style="color: black !important;" *ngFor="let item of meeting.participants | keyvalue">
      {{getDisplayName(item).displayName | titlecase}}   <p *ngIf="getIsUserHost(item)">(Host)</p>
      <span class="cus-icon-container" *ngIf="hostUser">
        <img style="width: 18px; margin-right: 5px;cursor: pointer;" (click)="toggleWebCam($event)"
          [attr.id]="getControlValue('video', item)"
          [src]="getDisplayName(item)?.webcamOn ? videocam_on :  videocam_off" alt="">
        <img style="width: 20px;cursor: pointer;" (click)="toggleMic($event)" [attr.id]="getControlValue('mic', item)"
           [src]="getDisplayName(item)?.micOn ? mic_on : mic_off" alt="">
        <img style="width: 20px;cursor: pointer;" (click)="toggleMic($event)" [src]="menu_icon" [matMenuTriggerFor]="menu">
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="removeParticipant(item)">
            <span >Remove User</span>
          </button>
        </mat-menu>
      </span>

    </mat-list-item>
  </mat-list>
</ng-template>
